import React from 'react';
import { cache } from 'utils';
import PropTypes from 'prop-types';
import './index.less';

const prefixCls = 'verify-privilege';

export default function VerifyPrivilege (props) {
	const { children, privilegeId } = props;

	// 判断是否有权限
	const hasPrivilege = () => {
		const privilegeIds = cache.get('privilegeIds') || [];
		// const { needAuthFlag = 0 } = window.$$merchantInfo || {};
		// 是否有权限 不在 privilegeIds 中说明没权限
		const isHasPrivilege = privilegeIds.indexOf(privilegeId) !== -1;
		// needAuthFlag === 1 说明需要权限校验， 不在 privilegeArr 中说明没权限
		// return needAuthFlag === 1 && isHasPrivilege;
		return isHasPrivilege;
	};

	// 无权限不展示
	if (!hasPrivilege()) {
		return null;
	}
	return (
		<div className={prefixCls}>
			{
				children
			}
		</div>
	);
}

VerifyPrivilege.propTypes = {
	privilegeId: PropTypes.number,
	children: PropTypes.element,
};
